module.exports = __webpack_public_path__ + "static/img/logo.06059f13.jpeg";